import { Title } from '@angular/platform-browser';
import { Component, OnInit, ViewChild } from '@angular/core';

import { LazyLoadEvent, ConfirmationService } from 'primeng/api';
import { ToastyService } from 'ng2-toasty';

import { ErrorHandlerService } from '../../core/error-handler.service';
import { ListStateReuseStrategy } from '../../core/routing/list-state-reuse.strategy';

// Variable in assets/js/scripts.js file
declare let AdminLTE: any;

@Component({
  standalone: false,
  selector: 'app-repasses-pesquisa',
  templateUrl: './repasses-pesquisa.component.html'
})
export class RepassesPesquisaComponent implements OnInit {

  manterFiltrosSelecionados = ListStateReuseStrategy.shouldKeepFiltersForCurrentUrl();

  totalRegistros = 0;
  filtro: any;
  dados = [];
  @ViewChild('tabela') grid;

  constructor() { }

  ngOnInit() {

    // Update the AdminLTE layouts
    AdminLTE.init();

  }
  alterarManterFiltrosSelecionados(manter: boolean) {
    ListStateReuseStrategy.setShouldKeepFiltersForCurrentUrl(manter);
  }
}